import classnames from 'classnames'
import { motion } from 'framer-motion'
import React, { PropsWithChildren } from 'react'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { isNotNull } from '../../utils/nonNull'
import { CustomLink } from '../CustomLink'
import { FadeInWhenVisible } from '../FadeInWhenVisible'
import { ProjectBannerMask } from './ProjectBannerMask'
import projectBannerStyles from './projectBanner.module.scss'


export type ProjectBannerComponentProps = {
  backgroundImage?: string
  backgroundMobileImage?: string
  foregroundImage?: string
  textColor?: string
  backgroundColor?: string
  title?: string
  introText?: string
  children?: React.ReactNode
  isListingPage?: boolean
  projectUrl?: string
  isProjectVideo?: boolean
  videoType?: string
  videoId?: string
}

export const ProjectBannerComponent:React.FC<PropsWithChildren<ProjectBannerComponentProps>> = ({
  children,
  backgroundImage,
  backgroundMobileImage,
  foregroundImage,
  textColor,
  backgroundColor,
  title,
  introText,
  isListingPage = false,
  projectUrl,
  isProjectVideo= false,
  videoType,
  videoId })=> {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const wrapperStyles = [projectBannerStyles.projectBannerWrapper]

  if (isListingPage) wrapperStyles.push(projectBannerStyles.listingPage)


  return projectBannerStyles.projectBanner ? (
    <div  style={{ background: !isListingPage ? backgroundColor : 'none' }}>
      <FadeInWhenVisible
        animation="easyFadeInStill"
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        <div className={classnames(wrapperStyles)}>
          <ProjectBannerMask
            src={isNotNull(backgroundImage) ? backgroundImage : ''}
            foregroundImage={foregroundImage}
            mobileSrc={isNotNull(backgroundMobileImage) ? backgroundMobileImage : ''}
            isProjectVideo={isProjectVideo}
            videoType={videoType}
            videoId={videoId}
            className={projectBannerStyles.projectBanner}
          >
            {(!isMobile && !isListingPage) && (
              <div className={projectBannerStyles.projectIntroTextContainer}>
                <div className={projectBannerStyles.projectIntroTextWrapper}>
                  <motion.h1
                    variants={{
                      visible: { opacity: 1, scale: 1, y: -40 },
                      hidden: { opacity: 0, scale: 1, y: 40 },
                    }}
                    transition={{
                      delay: .8,
                      duration: .5,
                    }}
                    style={{ color: textColor }}
                  >{title}</motion.h1>
                  <motion.p
                    variants={{
                      visible: { opacity: 1, scale: 1, y: -40 },
                      hidden: { opacity: 0, scale: 1, y: 40 },
                    }}
                    transition={{
                      delay: 1.5,
                      duration: .5,
                    }} style={{ color: textColor }}>{introText}</motion.p>
                </div>
              </div>
            )}
            {isListingPage &&  (
              <div className={projectBannerStyles.projectIntroTextContainer}>
                <div className={projectBannerStyles.projectIntroTextWrapper}>
                  <motion.h1
                    variants={{
                      visible: { opacity: 1, scale: 1, y: -40 },
                      hidden: { opacity: 0, scale: 1, y: 40 },
                    }}
                    transition={{
                      delay: .8,
                      duration: .5,
                    }}
                    style={{ color: textColor }}
                  >{title}</motion.h1>
                  <motion.div
                    variants={{
                      visible: { opacity: 1, scale: 1, y: -40 },
                      hidden: { opacity: 0, scale: 1, y: 40 },
                    }}
                    transition={{
                      delay: 1.5,
                      duration: .5,
                    }} style={{ color: textColor }}>
                    <CustomLink href={projectUrl || '/'} variant="primary-with-arrow" inverseColor={true}>
                    View project
                    </CustomLink>
                  </motion.div>
                </div>
              </div>
            )
            }
          </ProjectBannerMask>
        </div>
      </FadeInWhenVisible>
      {
        !isListingPage && (
          <FadeInWhenVisible
            animation="easyFadeInStill"
            transition={{ delay: .8 }}
          >
            <div className={classnames(projectBannerStyles.projectBannerContentWrapper)} style={{ background: backgroundColor }}>
              <FadeInWhenVisible
                animation="easyFadeInStill"
                transition={{ duration: .5 }}
              >
                {children && children}
              </FadeInWhenVisible>
            </div>
          </FadeInWhenVisible>
        )
      }
    </div>
  ) : null
}


